module.exports = __webpack_public_path__ + "media/fonts/SFProText-Light-1fdc96190293b32d5702ab0cbc386d81.ttf";